export default __webpack_public_path__ + "static/media/gd.70be022b.svg";